import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { MoneyInput } from "../atoms/MoneyInput";
import { PercentInput } from "../atoms/PercentInput";
import { MoneyUnderlinedInput } from "../atoms/MoneyUnderlinedInput";
import { PercentUnderlinedInput } from "../atoms/PercentUnderlinedInput";
import ILearn from "../molecules/ILearn";

class IrqDownPaymentView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/downpayment.svg"
          />
          <div className="down-payment-mobile">
            <div className="mobile-edit-row">
              <PercentInput
                name="downPayment"
                error={!!this.props.errors.downPayment}
                fullWidth
                value={this.props.values.downPayment || ""}
                price={this.props.data.price}
                onChange={this.props.onFormEdit}
                onBlur={this.props.onBlur}
                placeholder="3"
              />
            </div>
            <div className="or-down-payment-wrapper">
              <img src="/img/svg_icons/or_downpayment.svg" />
            </div>
            <div className="mobile-edit-row">
              <MoneyInput
                name="downPayment"
                error={!!this.props.errors.downPayment}
                fullWidth
                value={this.props.values.downPayment || ""}
                onChange={this.props.onFormEdit}
                onBlur={this.props.onBlur}
                placeholder="9,600"
                inputProps={{ max: this.props.data.price, min: 0 }}
              />
            </div>
          </div>
          <div className="down-payment-desktop">
            <div className="desktop-down-payment-item-wrapper">
              <PercentUnderlinedInput
                name="downPayment"
                error={!!this.props.errors.downPayment}
                value={this.props.values.downPayment || ""}
                price={this.props.data.price}
                onChange={this.props.onFormEdit}
                onBlur={this.props.onBlur}
                placeholder="3"
              />
            </div>
            <div className="or-desktop-down-payment-wrapper">
              <img src="/img/svg_icons/or_downpayment.svg" />
            </div>
            <div className="desktop-down-payment-item-wrapper">
              <MoneyUnderlinedInput
                name="downPayment"
                error={!!this.props.errors.downPayment}
                value={this.props.values.downPayment || ""}
                onChange={this.props.onFormEdit}
                onBlur={this.props.onBlur}
                placeholder="9,600"
                inputProps={{ max: this.props.data.price, min: 0 }}
              />
            </div>
          </div>
          <EditActions canSubmit={this.props.isValid} />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqDownPaymentView));
